import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import FormControl from "react-bootstrap/FormControl";
import Button from "react-bootstrap/Button";
import { FaCheck, FaTimes, FaPencilAlt, FaPlus } from "react-icons/fa";
import "./CrdzAddToCartModal.css"
import { addToCart } from "../../utilities/cartUtils";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchCartByCustomerId, updateCartName } from "../../redux/cartSlice";
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';

interface CartModalInterface {
    productObj: any,
    quantity: number,
    comboList: any,
    installationService: any,
    handleAddToCart: any,
    id: string,
    keepMounted: boolean;
    open: boolean;
    onClose: () => void;

}

const CrdzAddToCartModal: React.FC<CartModalInterface> = ({ productObj, quantity, comboList, installationService, handleAddToCart, id, keepMounted, open, onClose }) => {
    const [customerCarts, setCustomerCarts] = useState<any>();
    const [existingCartList, setExistingCartList] = useState<any>();
    const [carts, setCarts] = useState<any[]>([]);
    const [isEditing, setIsEditing] = useState<number | null>(null);
    const [editValue, setEditValue] = useState<string>("");
    const [value, setValue] = useState('');

    const radioGroupRef = React.useRef<HTMLElement>(null);

    const dispatch = useDispatch<any>();
    const history = useNavigate();

    useEffect(() => {
        const savedCartStr = localStorage.getItem("customercarts");
        let existingCarts: any[] = [];
        if (savedCartStr && savedCartStr !== "") {
            const savedCarts: any[] = JSON.parse(savedCartStr);
            setCustomerCarts(savedCarts);
            existingCarts = savedCarts!.map(cart => ({ id: cart.cartId, name: cart.cartName, keyId: cart.cartName + cart.cartId }));
            setExistingCartList(existingCarts)
        }

        let temporaryCarts: any[] = [];
        for (let i = existingCarts.length; i < existingCarts.length + 5; i++) {
            temporaryCarts.push({ id: 0, name: "Cart " + (i + 1), keyId: "Cart" + (i + 1) + 0 })
        }
        let updatedCartNames = [...existingCarts, ...temporaryCarts];
        updatedCartNames = updatedCartNames.splice(0, 5);
        setCarts(updatedCartNames);

    }, [])

    const handleEditClick = (index: number, e: React.MouseEvent) => {
        e.stopPropagation();
        setIsEditing(index);
        setEditValue(carts[index].name);
    };

    const handleAddCart = () => {

        const cart = carts.filter(cart => cart.keyId == value)

        const addCartResponse = addToCart(cart[0].name, productObj, quantity, comboList, installationService, dispatch);
        // console.log(value);
        handleOk();
        if (addCartResponse) {
            handleAddToCart("Product added to cart successfully");
        } else {
            history("/login");
        }
    }

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEditValue(e.target.value);
    };

    const handleSave = async (index: number, id: number, e: React.MouseEvent) => {
        e.stopPropagation();
        const updatedCarts = carts.map((item, cartIndex) =>
            cartIndex === index ? { ...item, name: editValue } : item
        );
        setCarts(updatedCarts);
        if (existingCartList && existingCartList.length > 0) {
            let existingCart = existingCartList.find((x: any) => x.id == id);
            if (existingCart) {
                let data = { cartId: existingCart.id, cartName: editValue };
                const response = await dispatch(updateCartName(data)).unwrap();
                dispatch(fetchCartByCustomerId());
            }
        }
        setIsEditing(null);
    };

    const handleCancel = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsEditing(null);
    };

    const handleAddNew = (e: React.MouseEvent) => {
        e.stopPropagation();
        const newCartName = `Cart ${carts.length + 1}`;
        setCarts([...carts, newCartName]);
    };

    const handleEntering = () => {
        if (radioGroupRef.current !== null) {
            radioGroupRef.current.focus();
        }
    };

    const handleCancelModal = () => {
        onClose();
    };

    const handleOk = () => {
        onClose();
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue((event.target as HTMLInputElement).value);
    };

    const handleLabel = (cart: any, index: any) => {
        return (
            isEditing === index ? (
                <div className="d-flex align-items-center">
                    {/* <span><strong>{cart.name}</strong></span> */}
                    <FormControl
                        type="text"
                        value={editValue}
                        onChange={handleInputChange}
                        className="me-2"
                        style={{
                            maxWidth: "300px",
                            flex: 1,
                            minWidth: "90px"
                        }}
                    />
                    <Button
                        size="sm"
                        variant="link"
                        onClick={(e) => handleSave(index, cart.id, e)}
                        className="me-2"
                    >
                        <SaveIcon />
                    </Button>
                    <Button
                        size="sm"
                        variant="link"
                        onClick={handleCancel}
                        className="me-2"
                    >
                        <CancelIcon color="error" />
                    </Button>
                </div>
            ) : (
                <div className="d-flex align-items-center justify-content-between cursor">
                    <Typography><strong>{cart.name}</strong></Typography>
                    <Button
                        style={{ paddingTop: '0px', visibility: cart.id !== 0 ? 'visible' : 'hidden' }}
                        size="sm"
                        variant="link"
                        onClick={(e) => handleEditClick(index, e)}
                    >
                        <EditIcon fontSize="small" />
                    </Button>
                </div>
            )
        )
    }

    return (
        // <DropdownButton
        //     id="add-to-cart-dropdown"
        //     title="ADD TO CART"
        //     variant="danger"
        //     autoClose={isEditing === null ? "outside" : false}
        // >

        //     {carts.map((cart: any, index) => (
        //         <Dropdown.Item key={index} as="div" onClick={() => handleAddCart(cart, index)}>
        //             {isEditing === index ? (
        //                 <div className="d-flex align-items-center">
        //                     <FormControl
        //                         type="text"
        //                         value={editValue}
        //                         onChange={handleInputChange}
        //                         className="me-2"
        //                         style={{
        //                             maxWidth: "300px",
        //                             flex: 1,
        //                             minWidth: "90px"
        //                         }}
        //                     />
        //                     <Button
        //                         size="sm"
        //                         variant="link"
        //                         onClick={(e) => handleSave(index, cart.id, e)}
        //                         className="me-2"
        //                     >
        //                         <FaCheck color="green" size={16} />
        //                     </Button>
        //                     <Button
        //                         size="sm"
        //                         variant="link"
        //                         onClick={handleCancel}
        //                         className="me-2"
        //                     >
        //                         <FaTimes color="red" size={16} />
        //                     </Button>
        //                 </div>
        //             ) : (
        //                 <div className="d-flex align-items-center justify-content-between cursor">
        //                     <span><strong>{cart.name}</strong></span>
        //                     <Button
        //                         size="sm"
        //                         variant="link"
        //                         onClick={(e) => handleEditClick(index, e)}
        //                     >
        //                         <FaPencilAlt color="orange" size={16} />
        //                     </Button>
        //                 </div>
        //             )}
        //         </Dropdown.Item>
        //     ))}

        //     <Dropdown.Divider />
        //     {carts && carts.length < 5 &&
        //         < Dropdown.Item as="button" onClick={handleAddNew} className="d-flex align-items-center">
        //             <FaPlus className="me-2" />
        //             Add New
        //         </Dropdown.Item>
        //     }

        // </DropdownButton>
        <>
            <form onSubmit={handleAddCart}>

                <Dialog
                    sx={{ '& .MuiDialog-paper': { maxHeight: 400, borderRadius: 3 } }}
                    maxWidth="xs"
                    TransitionProps={{ onEntering: handleEntering }}
                    open={open}
                    onClose={onClose}
                // onClick={() => handleAddCart()}
                // {...other}
                >
                    <DialogTitle sx={{ backgroundColor: '#d32f2f', color: '#fff', textAlign: 'left' }}>Add To Cart</DialogTitle>
                    <DialogContent dividers>
                        <Typography variant="subtitle2" sx={{ px: 1, fontSize: "16px" }}>Add products to your carts and easily compare prices across multiple options.</Typography>
                        <RadioGroup
                            sx={{ px: 2, mt: 1, alignItems: "left" }}
                            aria-label="ringtone"
                            name="ringtone"
                            value={value}
                            onChange={handleChange}
                        >
                            {carts.map((option, index = 0) => (
                                <>
                                    <FormControlLabel
                                        value={option.keyId}
                                        key={index}
                                        control={<Radio size="small" />}
                                        label={handleLabel(option, index)}
                                    />
                                </>
                            ))}

                        </RadioGroup>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="danger" size="sm" autoFocus onClick={handleCancelModal}>
                            <strong>Cancel</strong>
                        </Button>
                        <Button variant="contained" size="sm" type="submit" style={{ backgroundColor: '#0f456c', color: '#fff' }} onClick={handleAddCart} ><strong> Add</strong></Button>
                    </DialogActions>
                </Dialog>
            </form>
        </>
    );
};

export default CrdzAddToCartModal;
